module.exports = __webpack_public_path__ + "img/icon-timer-outline.f6d54d1a.svg";